import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogActionsEnum, DialogComponent} from '../../../../shared/components';

import {ConfirmationData} from '../../classes';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent extends DialogComponent<ConfirmationComponent> {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            confirmationData: ConfirmationData
        },
        public dialogRef: MatDialogRef<ConfirmationComponent>,
    ) {
        super(dialogRef);

        this.config = data.confirmationData.getConfig();
    }

    onActionButtonClicked(action: number): void {
        switch (action) {
            case DialogActionsEnum.Decline:
                this.dialogRef.close(false);
                break;
            case DialogActionsEnum.Confirm:
                this.dialogRef.close(true);
                break;
            default:
                this.dialogRef.close(false);
        }
    }
}
